import React from 'react';
import { Breadcrumbs as MUIBreadcrumbs, Link, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router';

interface BreadcrumbItem {
  label: string;
  href?: string;
  isCurrent?: boolean;
}

interface DynamicBreadcrumbsProps {
  items: BreadcrumbItem[];
  onItemClick?: (item: BreadcrumbItem) => void;
}

const StyledBreadcrumbs = styled(MUIBreadcrumbs)(({ theme }) => ({
  '& .MuiBreadcrumbs-separator': {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
}));

const DynamicBreadcrumbs: React.FC<DynamicBreadcrumbsProps> = ({ 
  items, 
  onItemClick 
}) => {
  const navigate = useNavigate();
  
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>, item: BreadcrumbItem) => {
    event.preventDefault();
    if (onItemClick) {
      onItemClick(item);
    } else {
      navigate(item.href || '/');
    }
  };

  return (
    <StyledBreadcrumbs
      aria-label="breadcrumbs"
    >
      {items.map((item, index) => (
        item?.isCurrent ? (
          <Typography
            key={index}
            color="text.secondary"
            sx={{
              color: '#222B45',
              fontWeight: '600',
              fontSize: '16px',
              cursor: 'default',
              userSelect: 'none',
            }}
          >
            {item.label}
          </Typography>
        ) : (
          <Link
            key={index}
            color="primary"
            underline="always"
            href={item.href || '#'}
            onClick={(e) => handleClick(e, item)}
            sx={{ 
              color: '#2c6ca0',
              fontWeight: '500',
              fontSize: '15px',
              textDecoration: 'underline',
              textUnderlineOffset: '3px',
              '&:hover': {
                textDecoration: 'underline',
              },
            }}
          >
            {item.label}
          </Link>
        )
      ))}
    </StyledBreadcrumbs>
  );
};

export default DynamicBreadcrumbs; 